import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "@/router/router";
import Vuesax from "vuesax3";
import axios from "axios";
import "vuesax3/dist/vuesax.css";
import "@/Style.css";
import "@/api/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import store from "./store";
import mitt from "mitt";
import i18n from "./i18n";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import 'leaflet/dist/leaflet.css'

const appInsights = new ApplicationInsights({
    config: {
        connectionString: window.VUE_APP_APPLICATIONINSIGHTS_CONNECTIONSTRING,
    },
});
import { getMessaging, onMessage } from "firebase/messaging";
const messaging = getMessaging();

// Initialize emitter
export const emitter = mitt();

// Handle foreground messages
onMessage(messaging, (payload) => {
    const jsondata = JSON.parse(payload.data.notification);
    console.log('Received foreground message:', jsondata);
    store.dispatch("setLtsNotification", jsondata);
});

// Set up broadcast channel for service worker communication
if ('BroadcastChannel' in window) {
    console.log('Setting up broadcast channel');
    const channel = new BroadcastChannel('sw-messages');

    // Listen for messages from service worker
    channel.addEventListener('message', event => {
        console.log('Received message from service worker:', event.data);
        if (event.data.type === 'BACKGROUND_NOTIFICATION') {
            console.log('Processing background notification:', event.data.payload);
            store.dispatch("setLtsNotification", event.data.payload.data);
        }
    });

    // Notify service worker that client is ready
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            console.log('Service Worker registration:', registration);
            if (registration.active) {
                console.log('Service Worker is active');
                channel.postMessage({ type: 'CLIENT_READY' });
            } else {
                console.log('Service Worker is not active, waiting for activation');
                registration.addEventListener('activate', () => {
                    console.log('Service Worker activated');
                    channel.postMessage({ type: 'CLIENT_READY' });
                });
            }
        }).catch(error => {
            console.error('Service Worker registration failed:', error);
        });
    }
} else {
    console.log('BroadcastChannel is not supported in this browser');
}

appInsights.loadAppInsights();
appInsights.trackPageView();

// Set up axios defaults and interceptors
axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("accessToken");

axios.interceptors.request.use(
    (config) => {
        if (localStorage.getItem("accessToken")) {
            config.headers["Authorization"] =
                "Bearer " + localStorage.getItem("accessToken");
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            emitter.emit("Active401WarningSnackBar");
        }
        return Promise.reject(error);
    }
);

// Create and mount the app
const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(Vuesax);
app.use(store);
app.use(i18n);
app.config.globalProperties.emitter = emitter;
app.mount("#app");
// await this.$store.dispatch('loginDelivery', actionPayload);
